<template>
  <!--  处理签名图片-->
  <div>
    <el-upload
        ref="upload"
        :action="baseUrl+'/file/upload'"
        :data="{category: 'user/sign'}"
        accept=".jpg,.png,.jpeg"
        :headers="headers"
        :file-list="fileList"
        :on-change="handleChange"
        :on-success="handleAvatarSuccessCheck"
        :before-upload="beforeAvatarUploadCheck"
        :class="{hide:hideUpload}"
        :auto-upload="false"
        list-type="picture-card">
      <i slot="default" class="el-icon-plus"><span
          style="display: block;font-size: 1rem;padding: 10px 20px;">点击上传{{ accepts }}类型的文件</span></i>
      <div slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <!--          <template v-if="show == 'edit' && !pageFile && newUpImg">-->
          <!--            <span class="el-upload-list__item-delete" @click="gray(file)">-->
          <!--              <i class="el-icon-crop"></i>-->
          <!--            </span>-->
          <!--          </template>-->
          <span v-if="show == 'edit'" class="el-upload-list__item-delete" @click="handleRemoveCheck()">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <!--    <el-button style="margin-top: 10px;" size="mini" type="success" @click="submitUpload" v-if="!pageFile && show == 'edit'">上传到服务器</el-button>-->
    <el-dialog title="图片预览" :visible.sync="dialogVisible" append-to-body top="10vh" v-dialogDrag>
      <div class="imgBox">
        <img width="100%" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>

    <el-dialog title="图片裁剪" :visible.sync="cropperDialog" append-to-body top="10vh" width="800px" v-dialogDrag :close-on-click-modal="false" @close="cropperClose">
      <div class="tip">操作说明：<span class="red">请尽量裁剪至所需内容边缘</span>，可使用鼠标滚轮控制图片大小，点击确认后将自动上传图片。</div>
      <div class="imgBox" v-if="cropperDialog" style="height: 500px;width: 700px;">
        <vue-cropper
            ref="cropper"
            :img="option.img"
            :autoCropWidth="9999"
            :autoCropHeight="9999"
            :autoCrop="true"
            :centerBox="true"
        />
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button size="mini" type="success" @click="getCropperData">确认上传图片</el-button>
        <el-button size="mini" @click="cropperDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import baseUrl, {imageUrl} from "../constants";
import {transformSignatureImage} from "../common/processGray.js"
import {VueCropper} from "vue-cropper";
import utils from "@/common/utils";

@Component({
  components: {VueCropper}
})
export default class UnitData extends Vue {
  title = "处理签名图片";
  @Prop() oldSignImage;
  @Prop() show; // edit show

  baseUrl = baseUrl
  imageUrl = imageUrl
  headers = {Authorization: ""}
  fileList = [];
  hideUpload = false // 是否隐藏上传框
  pageFile = '' // 上传后的图片地址
  accepts = ['JPEG', 'JPG', 'PNG']
  dialogImageUrl = ''
  dialogVisible = false
  newUpImg = false;
  uploadStatus = false; // 是否提交裁剪

  signImage = ''; // 当前图片

  option = {
    img: '', // 裁剪图片的地址
    info: true, // 裁剪框的大小信息
    outputSize: 1, // 裁剪生成图片的质量
    outputType: 'jpeg', // 裁剪生成图片的格式
    canScale: false, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    fixedBox: true, // 固定截图框大小 不允许改变
    fixed: true, // 是否开启截图框宽高固定比例
    fixedNumber: [5, 7], // 截图框的宽高比例
    full: true, // 是否输出原图比例的截图
    canMoveBox: false, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: false, // 截图框是否被限制在图片里面
    infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
  }

  @Watch('oldSignImage')
  changeOldSignImage() {
    this.signImage = this.oldSignImage;
    this.option.img = imageUrl + this.oldSignImage;
    this.fileList = [{name: '签名', url: imageUrl + this.signImage}];
    this.hideUpload = true;
  }

  // 选择文件
  handleChange(file, fileLists) {
    this.hideUpload = true;
    if (!this.newUpImg) {
      this.newUpImg = true;
      this.gray(file);
    } else {
      this.newUpImg = false;
    }
  }

  handleAvatarSuccessCheck(res, file) {
    if (res.result === 0) {
      const rData = res.data;
      this.fileList = [{name: this.title, url: imageUrl + rData}];
      this.pageFile = rData;
      this.hideUpload = true;
      this.$emit("onSuccess", res);
    }
  }

  handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  beforeAvatarUploadCheck(file) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    const lastIndex = file.name.lastIndexOf(".");
    if (lastIndex === -1) {
      this.$message.error('此文件格式不存在');
      return false;
    }
    //后缀
    const suffix = file.name.substring(lastIndex + 1, file.name.length);
    if (this.accepts.indexOf(suffix.toUpperCase()) > -1) {
      return new Promise((resolve) => {
        resolve(utils.base64ConvertFile(this.upFileData.url, '签名图'));
      });
    } else {
      this.$message.error('上传只能是 ' + this.accepts.join(" 或 ") + ' 格式!');
      return false;
    }
  }

  cropperDialog = false;
  upFileData = null;

  gray(file) {
    this.uploadStatus = false;
    transformSignatureImage(file.url).then((e) => {
      file.url = e;
      this.upFileData = file;
      this.option.img = e;
      this.cropperDialog = true;
    })
  }

  handleRemoveCheck() {
    this.fileList = [];
    this.pageFile = '';
    this.hideUpload = false;
  }

  submitUpload() {
    (this.$refs.upload).submit();
  }

  getCropperData() {
    this.uploadStatus = true;
    (this.$refs.cropper).getCropData((data) => {
      this.upFileData.url = data;
      this.cropperDialog = false;
      this.$nextTick(() => {
        this.submitUpload();
      })
    })
  }

  // 关闭弹窗
  cropperClose() {
    if (!this.uploadStatus) {
      this.newUpImg = false;
      this.fileList = [{name: '签名', url: imageUrl + this.signImage}];
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.hide .el-upload--picture-card) {
  display: none;
}
.el-upload-list__item-thumbnail {
  margin: 20px auto;
}
.tip {
  margin-top: -30px;
  margin-bottom: 10px;
  .red {
    color: red;
  }
}
::v-deep  .el-upload--picture-card{
  padding-top: 16px;
}
// 删除图片闪动特效去掉
::v-deep .el-upload-list__item{
  transition:none !important;
  -webkit-transition:nonne !important;
}
::v-deep .el-upload-list__item-name{
  transition:none !important;
  -webkit-transition:nonne !important;
}
</style>
